module.exports = __webpack_public_path__ + "static/assets/4dd17422fd9af84cc8629479d4e13a1d.svg";